import { motion, useReducedMotion } from 'framer-motion';

// Grano de película sutil sobre el fondo.
export const GRAIN = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

export function Grain() {
  return <div aria-hidden className="pointer-events-none fixed inset-0 opacity-[0.035]" style={{ backgroundImage: GRAIN }} />;
}

export function Wordmark({ className = '' }) {
  return (
    <span className={`font-inter font-semibold uppercase tracking-[0.32em] text-lounge-text ${className}`}>
      Rockcola
    </span>
  );
}

// Enter y RoomView muestran este loader seguido: solo la primera aparición anima la entrada,
// así el cambio de pantalla no parpadea.
let loaderShown = false;

export function LoadingScreen({ text = 'Preparando la sala…' }) {
  const reduce = useReducedMotion();
  const animate = !reduce && !loaderShown;
  loaderShown = true;
  return (
    <div className="flex min-h-dvh items-center justify-center bg-lounge-base">
      <motion.div
        initial={animate ? { opacity: 0, y: 6 } : false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="text-center"
      >
        <Wordmark className="text-sm" />
        <p className="mt-4 animate-pulse font-serif text-lg italic text-lounge-stone motion-reduce:animate-none">
          {text}
        </p>
      </motion.div>
    </div>
  );
}

// Pantalla centrada de una sola tarjeta (error, cooldown).
export function LoungeScreen({ children }) {
  const reduce = useReducedMotion();
  return (
    <div className="relative flex min-h-dvh flex-col items-center bg-lounge-base px-5 font-inter text-lounge-text
                    antialiased pb-[calc(2rem+env(safe-area-inset-bottom))] pt-[calc(1.5rem+env(safe-area-inset-top))]">
      <Grain />
      <Wordmark className="relative text-[13px]" />
      <motion.main
        initial={reduce ? false : { opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative flex w-full max-w-[400px] flex-1 flex-col items-center justify-center text-center"
      >
        <div
          aria-hidden
          className="pointer-events-none absolute h-64 w-64 rounded-full bg-lounge-brass/[0.07] blur-[80px]"
        />
        {children}
      </motion.main>
    </div>
  );
}
